import { ChangeDetectionStrategy, Component, Input, OnInit, ViewChild } from '@angular/core'
import { SlickCarouselComponent } from 'ngx-slick-carousel'
import { IStyle } from '../../../Interface/style'
import { SsrService } from '../../../services/ssr.service'

@Component({
  selector: 'bmcore-genres-slider',
  templateUrl: './bmcore-genres-slider.component.html',
  styleUrls: ['../bmcore-slider.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreGenresSliderComponent implements OnInit {
  @Input() popularGenres: Array<IStyle>

  @ViewChild('slickModal') slickModal: SlickCarouselComponent

  slideConfig = {
    slidesToShow: 4,
    slidesToScroll: 4,
    nextArrow: "<div class='nav-btn next-slide'>&#10093;</div>",
    prevArrow: "<div class='nav-btn prev-slide'>&#10092;</div>",
    dots: false,
    infinite: false,
    speed: 500,
    autoplay: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          arrows: false,
          dots: true
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          arrows: false,
          dots: true
        }
      },
      {
        breakpoint: 360,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true
        }
      }
    ]
  }

  constructor(private ssrService: SsrService) {}

  ngOnInit(): void {
    this.ssrService.isRehydratedSubject.subscribe(isRehydrated => {
      if (isRehydrated) {
        this.slickModal?.unslick()
        this.slickModal?.initSlick()
      }
    })
  }
}
